import { render, staticRenderFns } from "./tableC.vue?vue&type=template&id=2d6c44ec&scoped=true&"
import script from "./tableC.vue?vue&type=script&lang=js&"
export * from "./tableC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c44ec",
  null
  
)

export default component.exports